import { render, staticRenderFns } from "./Fude.vue?vue&type=template&id=1e621c9e&scoped=true&"
import script from "./Fude.vue?vue&type=script&lang=js&"
export * from "./Fude.vue?vue&type=script&lang=js&"
import style0 from "./Fude.vue?vue&type=style&index=0&id=1e621c9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e621c9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e621c9e')) {
      api.createRecord('1e621c9e', component.options)
    } else {
      api.reload('1e621c9e', component.options)
    }
    module.hot.accept("./Fude.vue?vue&type=template&id=1e621c9e&scoped=true&", function () {
      api.rerender('1e621c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/deceased/enshrineList/Fude.vue"
export default component.exports